import { RequireAuth, UserRole } from 'legoland-sdk/dist/experimental';
import { useState } from 'react';
import styled from 'styled-components';
import { Box, Button, Label, tombac, useTombac } from 'tombac';
import { DeleteIcon, EditIcon } from 'tombac-icons';
import { DeleteSharedLimitsModal } from "./DeleteSharedLimitsModal";
import { LimitSummaryList } from "./LimitSummaryList";
import { sharedLimitSchemas } from "./sharedLimitSchemas";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SharedLimitsButton = styled(Button).withConfig({
  displayName: "SharedLimitsSummary__SharedLimitsButton"
})(["background-color:", ";"], tombac.color('neutral', 400));
export const SharedLimitsSummary = _ref => {
  let {
    onRequestEditOpen,
    productLimits,
    sharedLimitsPackage,
    contractId
  } = _ref;
  const tombac = useTombac();
  const limits = sharedLimitsPackage.limits;
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const tsEffectiveLimitsQuery = productLimits.filter(p => p.product.id === 'ts')[0];
  const odEffectiveLimitsQuery = productLimits.filter(p => p.product.id === 'od')[0];
  const usages = {
    ...odEffectiveLimitsQuery.usage,
    ...tsEffectiveLimitsQuery.usage
  };
  return /*#__PURE__*/_jsxs(Box, {
    $backgroundColor: "--neutral-400",
    $borderRadius: "10u",
    $display: "grid",
    $gap: "20u",
    $gridTemplateColumns: "96u 1fr max-content",
    $p: "2sp",
    "data-sentry-element": "Box",
    "data-sentry-component": "SharedLimitsSummary",
    "data-sentry-source-file": "SharedLimitsSummary.tsx",
    children: [/*#__PURE__*/_jsx(Label, {
      as: "div",
      $mt: "4u",
      "data-sentry-element": "Label",
      "data-sentry-source-file": "SharedLimitsSummary.tsx",
      "data-sentry-element": "Label",
      children: "Shared limits"
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LimitSummaryList, {
        limits: limits ?? {},
        schemas: sharedLimitSchemas,
        usages: usages,
        "data-sentry-element": "LimitSummaryList",
        "data-sentry-source-file": "SharedLimitsSummary.tsx",
        "data-sentry-element": "LimitSummaryList"
      }), /*#__PURE__*/_jsx(RequireAuth, {
        role: [UserRole.Admin, UserRole.Distributor],
        "data-sentry-element": "RequireAuth",
        "data-sentry-source-file": "SharedLimitsSummary.tsx",
        "data-sentry-element": "RequireAuth",
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(SharedLimitsButton, {
            onClick: () => onRequestEditOpen(),
            shape: "circle",
            size: "xs",
            variant: "flat",
            "data-sentry-element": "SharedLimitsButton",
            "data-sentry-source-file": "SharedLimitsSummary.tsx",
            "data-sentry-element": "SharedLimitsButton",
            children: /*#__PURE__*/_jsx(EditIcon, {
              "data-sentry-element": "EditIcon",
              "data-sentry-source-file": "SharedLimitsSummary.tsx",
              "data-sentry-element": "EditIcon"
            })
          }), limits && /*#__PURE__*/_jsx(SharedLimitsButton, {
            $ml: "0.5sp",
            onClick: () => setIsRemoveOpen(true),
            shape: "circle",
            size: "xs",
            variant: "flat",
            children: /*#__PURE__*/_jsx(DeleteIcon, {
              color: tombac.color('danger')
            })
          }), /*#__PURE__*/_jsx(DeleteSharedLimitsModal, {
            isOpen: isRemoveOpen,
            onRequestClose: () => setIsRemoveOpen(false),
            limits: limits,
            contractId: contractId,
            "data-sentry-element": "DeleteSharedLimitsModal",
            "data-sentry-source-file": "SharedLimitsSummary.tsx",
            "data-sentry-element": "DeleteSharedLimitsModal"
          })]
        })
      })]
    })]
  });
};